import React from "react";
var __jsx = React.createElement;
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import stl from "./AfterSubmitComp.module.css";
import useHelpers from "@hooks/useHelpers";
var AfterSubmitComp = function AfterSubmitComp(_ref) {
  var imgPath = _ref.imgPath,
    title = _ref.title,
    subTitle = _ref.subTitle,
    message = _ref.message,
    buttonText = _ref.buttonText,
    className = _ref.className,
    _onClick = _ref.onClick,
    hasClassDone = _ref.hasClassDone;
  var webview = useWebView();
  var isWebView = useIsWebView();
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.wrapper, " ").concat(className ? className : "")
  }, /*#__PURE__*/React.createElement("img", {
    src: imgPath,
    alt: "Result icon"
  }), /*#__PURE__*/React.createElement("strong", null, title), subTitle && /*#__PURE__*/React.createElement("strong", null, subTitle), /*#__PURE__*/React.createElement("h2", null, message), /*#__PURE__*/React.createElement("button", {
    className: hasClassDone ? "submitSurveyBtn" : undefined,
    onClick: function onClick() {
      !hasClassDone && _onClick();
      hasClassDone && webview.openScreen("home", {})["catch"](function () {
        if (isWebView) {
          return webview.closeScreen()["catch"](function () {
            return document.location.href = "app://close";
          });
        } else {
          _onClick();
        }
      });
    }
  }, buttonText));
};
export default AfterSubmitComp;